module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-form', [_vm._l((_vm.items), function(work, index) {
    return _c('div', {
      key: index,
      staticClass: "container"
    }, [_vm._l((_vm.keys), function(key) {
      return _c('el-form-item', {
        key: key,
        attrs: {
          "label": _vm.labels[key] || key
        }
      }, [_c('el-input', {
        model: {
          value: (work[key]),
          callback: function($$v) {
            _vm.$set(work, key, $$v)
          },
          expression: "work[key]"
        }
      })], 1)
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          return _vm.removeItems(index)
        }
      }
    })], 2)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addItems()
      }
    }
  }, [_vm._v("添加一项")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33715537","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrayEditor.vue
// module id = 188
// module chunks = 1